import Vue from "vue";
import Router from "vue-router";

import store from "./store";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Users from "./views/Users.vue";
import Companies from "./views/Companies.vue";
import Popup from "./views/Popup.vue";
import Dashboard from "./views/Dashboard.vue";
import Flow from "./views/Flow.vue";
import Settings from "./views/Settings.vue";
import Log from "./views/Log.vue";
import Account from "./views/Account.vue";
import QcareOverview from "./views/QcareOverview.vue";
import QcareSettings from "./views/QcareSettings.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        title: "Home - 4CareTelecom"
        // metaTags: [
        //   {
        //     name: 'description',
        //     content: 'The about page of our example app.'
        //   },
        //   {
        //     property: 'og:description',
        //     content: 'The about page of our example app.'
        //   }
        // ]
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/account",
      name: "Account",
      component: Account,
      meta: {
        title: "Account - 4CareTelecom"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        title: "Dashboard - 4CareTelecom"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/qcare",
      name: "Qcare",
      component: QcareOverview,
      meta: {
        title: "Qcare - 4CareTelecom"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/qcare-settings",
      name: "Qcare instellingen",
      component: QcareSettings,
      meta: {
        title: "Qcare Instellingen - 4CareTelecom"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/flow",
      name: "Flow",
      component: Flow,
      meta: {
        title: "Flow - 4CareTelecom"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "Inloggen - 4CareTelecom"
      },
      props: route => ({
        destination: route.query.d
      }),
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/users",
      name: "Gebruikers",
      component: Users,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          // console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/dashboard");
        }
      },
      meta: {
        title: "Gebruikers - 4CareTelecom"
      }
    },
    {
      path: "/log",
      name: "Log",
      component: Log,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          // console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/dashboard");
        }
      },
      meta: {
        title: "Log - 4CareTelecom"
      }
    },
    {
      path: "/companies",
      name: "Aansluitingen",
      component: Companies,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          // console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/dashboard");
        }
      },
      meta: {
        title: "Aansluitingen - 4CareTelecom"
      },
    },
    {
      path: "/popup",
      name: "Popup",
      component: Popup,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          // console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/dashboard");
        }
      },
      meta: {
        title: "Popup instellingen - 4CareTelecom"
      },
    },
    {
      path: "/algemene-instellingen",
      name: "Algemene instellingen",
      component: Settings,
      beforeEnter(to, from, next) {
        if (
          store.state.userRole == "superadmin" ||
          store.state.userRole == "admin" ||
          store.state.userRole == "manager"
        ) {
          // console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/dashboard");
        }
      },
      meta: {
        title: "Algemene instellingen - 4CareTelecom"
      }
    } 
  ]
});


